<div
  fxLayout="column"
  fxFlexAlign="space-around flex-start"
  class="wrapper p-40"
>
  <div class="text-wrapper mb-20">
    <p class="sub-title font-22">
      {{ 'profile.editImage' | translate }}
    </p>
  </div>
  <div fxLayout="column" fxLayoutAlign="space-between center mb-20">
    <img class="profile-image" [src]="croppedImage" alt="" />
    <button
      id="choosePhoto"
      class="text-white"
      mat-stroked-button
      (click)="choosePhoto()"
    >
      {{ 'profile.changeImage' | translate }}
    </button>
    <input
      #fileInput
      type="file"
      id="fileInput"
      accept="image/jpeg,image/png,image/gif,image/webp"
      (change)="fileChangeEvent($event)"
    />
  </div>
  <image-cropper
    class="mt-20"
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="false"
    [canvasRotation]="canvasRotation"
    [transform]="transform"
    [alignImage]="'center'"
    [style.display]="showCropper ? null : 'none'"
    format="jpeg"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (loadImageFailed)="loadImageFailed()"
  ></image-cropper>
  <div fxLayoutAlign="center center" class="image-options mt-3 mb-6">
    <mat-icon class="text-white" (click)="rotateLeft()">rotate_left</mat-icon>
    <mat-icon class="text-white" (click)="rotateRight()">rotate_right</mat-icon>
    <mat-icon class="text-white" id="flipHorizontal" (click)="flipHorizontal()"
      >align_horizontal_center</mat-icon
    >
    <mat-icon (click)="flipVertical()">align_vertical_center</mat-icon>
  </div>
  <div
    fxLayout="row"
    fxFlexAlign="center center"
    class="actions-wrapper w-full mt-20"
  >
    <button
      id="cancel-button"
      class="cancel-btn"
      mat-raised-button
      (click)="close()"
    >
      {{ 'general.cancel' | translate }}
    </button>
    <button
      class="aum-button"
      color="primary"
      mat-raised-button
      [mat-dialog-close]="croppedImage"
      [disabled]="!croppedImage"
    >
      {{ 'general.save' | translate }}
    </button>
  </div>
</div>
